import React, { useState } from "react";

const Section0 = ({products, setSelect, setStep}) => {

    const [orderCount, setOrderCount] = useState(0)

    let course = document.querySelector('#course');

    let calcForm = document.querySelector('section#calc-form')

    function OrderTable(){
        if ( typeof(Storage) !== "undefined" ) {

            let keys = Object.keys(localStorage)
            keys = keys.filter(key => key.match('order-') !== null)

            if (keys.length === 0){
                calcForm.style.display = 'none'
                return <h3>{window.lang['s0']['no_orders']}</h3>
            }else{
                calcForm.style.display = 'block'

                calcForm.querySelector('input[name="select-data"]').value = `${window.lang['s0']['complete_order']}`

                setOrderCount(keys.length)

                return (
                    <>
                        <div className="orders-table">

                            <span className="header">{window.lang['s']['table_headers']['material']}</span>
                            <span className="header">{window.lang['s']['table_headers']['options']}</span>
                            <span className="header">{window.lang['s']['table_headers']['size']}</span>
                            <span className="header">{window.lang['s']['table_headers']['cut']}</span>
                            <span className="header">{window.lang['s']['table_headers']['colours']}</span>
                            <span className="header">{window.lang['s']['table_headers']['price']}</span>
                            <span className="header">{window.lang['s']['table_headers']['action']}</span>

                            {keys.map((item) =>  orderRow( JSON.parse(localStorage.getItem(item))) )}

                        </div>
                        <h3>{window.lang['s0']['complete_order']}</h3>
                    </>
                )
            }

        } else {
            setStep(1)
            return (
                <>
                    <h3>Local storage not supported by your browser!</h3>
                </>
            )
        }
    }

    function RemoveItemButton(order){
        return <button 
            className="order-remove" 
            data-order={order.order}
            data-timeout="0"
            
            onClick={(event) => orderRemove(event)}
            > {window.lang['s0']['remove']} </button>
    }
    /*
    function handleInitiateOrderRemove(event){
        let button = event.target
        let timeout = parseInt(event.target.dataset.timeout)
        
        clearTimeout(button.downTimer)
        button.innerText = 'Точно удалить?'
        button.downTimer = setTimeout(function() {
            handleOrderRemove(event,timeout+50) 
        }, 20);
    }

    function handleOrderRemove(event, timeout = undefined){
        let button = event.target
        if (timeout === undefined) timeout = parseInt(button.dataset.timeout)
        
        if (timeout > 0 && timeout < 100){
            button.dataset.timeout = timeout - 1
            button.style.setProperty('--width',timeout+'%')

            clearTimeout(button.downTimer)
            button.downTimer = setTimeout(function() {
                handleOrderRemove(event) 
            }, 20)

        }else if (timeout > 100){
            clearTimeout(button.downTimer)
            orderRemove(event)
        }else{
            button.style.setProperty('--width', 0)
            button.innerText = 'Удалить?'
            clearTimeout(button.downTimer)
        }
        
    }*/

    function orderRemove(event){
        let button = event.target
        let order = button.dataset.order

        localStorage.removeItem(order)
        setOrderCount( Object.keys(localStorage).filter(key => key.match('order-') !== null).length )
    }

    function orderRow(item){

        calcForm.querySelector('input[name="select-data"]').value +=`        
        ${window.lang['s']['table_headers']['material']}: ${products[item.material].name}
        ${window.lang['s']['table_headers']['options']}: ${item.optionNames.join(', ')}
        ${window.lang['s']['table_headers']['size']}: ${item.length} ${window.lang['s']['units']['cm']} x ${item.height} ${window.lang['s']['units']['cm']}  
        ${item.cutStyle ? window.lang['s']['in_cut'] : window.lang['s']['in_rolls']} ${item.cut_flag ? ', ' + window.lang['s']['flagged'] : ''} ${item.amount} ${item.cutStyle ? window.lang['s']['units']['count'] : window.lang['s']['units']['rolls']}${!item.cutStyle ? ` (${item.amount*item.roll_length}${window.lang['s']['units']['meters']})` : null}
        ${window.lang['s']['table_headers']['colours']}: ${window.lang['s']['background']} ${item.colors.main} / ${window.lang['s']['logo']} ${item.colors.other}
        ${window.lang['s']['table_headers']['price']}: ${parseInt(item.calculatedPrice * parseFloat(course.innerText))} ${window.lang['s']['units']['uah']}.
        `

        return(
            <>
                <span>{products[item.material].name}</span>
                <span>{item.optionNames.join(', ')}</span>
                <span>{item.length} {window.lang['s']['units']['cm']} x {item.height} {window.lang['s']['units']['cm']}</span>
                <span>{item.cutStyle ? window.lang['s']['in_cut'] : window.lang['s']['in_rolls']}{item.cut_flag ? ', ' + window.lang['s']['flagged'] : ''} <br/>{item.amount} {item.cutStyle ? window.lang['s']['units']['count'] : window.lang['s']['units']['rolls']}{!item.cutStyle ? ` (${item.amount*item.roll_length}${window.lang['s']['units']['meters']})` : null}</span>
                <span>{window.lang['s']['background']}: {item.colors.main} <br/>{window.lang['s']['logo']}: {item.colors.other}</span>
                <span>{parseInt(item.calculatedPrice * parseFloat(course.innerText))} {window.lang['s']['units']['uah']}</span>
                <span><RemoveItemButton order={item.created} /></span>
            </>
        )
    }

    function startOrder(){
        calcForm.style.display = 'none'
        setStep(1)
        setSelect({ // '-1' === undefined
            material: -1, 
            submaterial: -1, 
            cut: false,
            cut_flag: false,
            roll: false,
            cutStyle: undefined,
            roll_length: -1,
            length: 0,
            height: 0, 
            indents: 0.5,
            logo: 'BirkisLogo',
            amount: 0,
            basicPrice: {
                priceForAmout: 0
            },
            options: {
                by_amount: 1,
                by_length: 1,
                by_width: 1,
                by_color_count: 1
            },
            finalPrice: {},
            colors:{
                main:'',
                other:''
            },
            calculatedPrice: -1,
            optionsNames:[],
            created: 0
        })
    }

    function NavButtons(){
        if ( orderCount > 0){
            return(
                <div className="step-btns">
                    <button className="btn btn-place-order" onClick={() => document.querySelector('#calc-form').scrollIntoView(true)} ><span>{window.lang['s0']['btn_order']}</span></button>
                    <button className="btn btn-next" onClick={() => startOrder()} ><span>{window.lang['s0']['btn_next']}</span></button>
                </div>
                )
        }else{
            return(
                    <div className="step-btns">
                        <button className="btn btn-next" onClick={() => startOrder()} >{window.lang['s0']['btn_addfirst_order']}</button>
                    </div>
                )
        }
    }


    return(
        <>
            <div className="section_header">
                <h1>{window.lang['s0']['title']}</h1>
                <NavButtons />
            </div>
            <OrderTable />
            <NavButtons />
        </>
    )
}
export default Section0;